import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class UpdateService {

    constructor(private http: HttpClient) {

    }

    //get all notification of user
    getAllNotification(filters : any) : Observable<any>{
        return this.http.post<any>(`${environment.baseUrl}/notification/filter/all`,filters)
        .pipe(
            map( res => res)
        )
    }
  //get all notification of user without filter
    getAllNotificationWithoutFilter() : Observable<any>{
        return this.http.get<any>(`${environment.baseUrl}/notification/all`)
        .pipe(
            map( res => res)
        )
    }

    //get all notification of user
    getOrderStatusNotification(filters : any) : Observable<any>{
        return this.http.post<any>(`${environment.baseUrl}/notification/change-status`,filters)
        .pipe(
            map( res => res)
        )
    }

    //get all notification of user
    getNewOrdersNotification(filters : any) : Observable<any>{
        return this.http.post<any>(`${environment.baseUrl}/notification/new-order`,filters)
        .pipe(
            map( res => res)
        )
    }

    //get all notification of user
    getOtherNotification(filters : any) : Observable<any>{
        return this.http.post<any>(`${environment.baseUrl}/notification/other`,filters)
        .pipe(
            map( res => res)
        )
    }

    readNotification(notification : any) : Observable<any>{
        return this.http.put<any>(`${environment.baseUrl}/notification/read`,notification)
        .pipe(
            map( res => res)
        )
    }

}